<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row>
          <b-col sm="12">
            <b-row>
              <b-col sm="4">
                <span class="pr-"><strong>총 {{items.length}}건</strong></span>
              </b-col>
              <b-col sm="3"></b-col>
              <b-col sm="3"></b-col>
              <b-col md="2" class="my-1">
                <b-row>
                  <b-col sm="6">
                    <b-button size="sm" variant="danger" v-on:click="drNewsLetterDelete()" :disabled="drDeleteRows.length == 0" :class="drDeleteRows.length != 0 ? 'mx-1 delete_button_on' : 'mx-1 delete_button_off'">
                      <h5 style="margin-bottom:0px">
                        <i class="fa fa-remove"></i> 삭제
                      </h5>
                    </b-button>

                  </b-col>
                  <b-col sm="6">
                    <b-form-select v-model="perPage" :options="pageOptions"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

          <!-- 로딩 -->
          <b-col sm="12" v-show="listLoading">
            <b-row>
              <b-col sm="5"></b-col>
              <b-col sm="5" class="pt-5 pb-5">
                <PulseLoader color="#20a8d8"></PulseLoader>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1" v-show="!listLoading">
            <b-row>
              <b-col sm="12">
                <b-table striped hover :fields="fieldItems" :items="items" :busy="items == 0" :current-page="currentPage" :per-page="perPage">
                  <div slot="table-busy" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </div>
                  <template slot="selectcheck" slot-scope="data">
                    <div>
                      <input type="checkbox" class="datarows" v-model="data.item.selectchecked" v-on:change="drListRows()" style="vertical-align:middle; width:20px; height:20px">
                    </div>
                  </template>

                  <template slot="active_yn" slot-scope="data">
                    <div>
                      <c-switch type="text" :id="'activeSelect'+data.item.rnum" variant="primary" v-model="data.item.use_yn"  v-on:change="LetterActiveYN(data.item)" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                    </div>
                  </template>

                  <template slot="nl_subject" slot-scope="data">
                    <div><a href="javascript:void(0)" v-on:click="newsLetterInfoGo(data.item)">{{data.item.nl_subject}}</a></div>
                  </template>
                  <template slot="nl_summary" slot-scope="data">
                    <div>{{data.item.nl_summary}}</div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-col>

          <b-col sm="12" class="pt-sm-1">
            <b-row class="pb-sm-2">
              <b-col sm="12" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="items.length" :per-page="perPage" align="center"/>
              </b-col>
            </b-row>
          </b-col>

        </b-row>

        <div style="float:right">
          <b-button variant="info" style="color:#ffffff" v-bind:href="'#/letter/newsletter/form?status=insert'">
            <i class="fa fa-hand-o-up"/> 신규등록
          </b-button>
        </div>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>


import cSwitch from '../../../components/Switch'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../event-bus";
import swal from "sweetalert2";
const moment = require("moment");

export default {
  name: 'LetterList',
  props: {
    queryParams: {
      type: Object
    },
    fieldItems: {
      type: Array
    },
    fullDate: {
      type: Array
    },
  },

  components: {
    PulseLoader,
    cSwitch
  },
  created() {
    // 이벤트 버스 선언
    EventBus.$on("callFindNews", () => {
      this.findDrNewsLetterList();
    });
  },
  data () {
    return {
      listLoading: false,
      letterListSelect: false,
      drDeleteRows: [],
      selectSlotNumbers: [],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 30, 50, 100],
      selectAll: false,
      slotParams: {},
      items: [],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  watch: {
    'letterListSelect'() {
      this.drDeleteRows = [];
    }
  },
  mounted() {
    this.listLoading=true;
    this.findDrNewsLetterList();
  },
  methods: {

    LetterActiveYN(data) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var item = data;

      console.log('itesms >>',item);

      self.$http.get('/api/update/LetterActiveYN?access_token='+token + '&lettercode='+item.letter_code + '&use_yn='+item.use_yn)
        .then((result) => {
          self.findDrNewsLetterList();
        })
    },

    findDrNewsLetterList() {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      this.listLoading = true;
      self.queryParams.start_date = this.$parent.getFormatDate(this.fullDate[0]);
      self.queryParams.end_date = this.$parent.getFormatDate(this.fullDate[1]);

      var param = encodeURI(JSON.stringify(self.queryParams));

      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/drNewsLetterList?access_token=' + token, data, null)
        .then((result) => {
          this.listLoading = false;
          self.items = result.data;
          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
            el.selectchecked = false;
          });
        })
    },

    drListRows() {
      var self = this;
      self.drDeleteRows = [];
      self.items.forEach(function (el, idx, arr){
        if(el.selectchecked){
          self.drDeleteRows.push(el.letter_code);
        }
      });
    },
    drNewsLetterDelete(){
      var self = this;
      swal.fire({
        title: '뉴스레터 삭제!',
        // text: "기본정보 이외에 작성한 데이터는 모두 초기화 됩니다. "+messageValue+"로 변경하시겠습니까?",
        html: "<b>현재의 뉴스레터 저장된 데이터</br> 모두 삭제 됩니다. 삭제하시겠습니까?</br><span style='color:#ea0000'>삭제 데이터 수 : "+self.drDeleteRows.length+"건</span></b>",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK'
      }).then((swalResult) => {
        if (swalResult.value) {
          // ok
          console.log(self.drDeleteRows);
          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.drDeleteRows));
          var data = new FormData();
          data.append('drDelArr', param);

          self.$http.post('/api/delete/drNewsLetter?access_token='+token, data, null)
            .then((result) => {
              swal.fire({
                type: 'success',
                title: '뉴스레터가 삭제되었습니다.',
                showConfirmButton: false,
                timer: 1000
              }).then(function() {
                self.drDeleteRows = [];
                $(".datarows").prop("checked", false);
                self.findDrNewsLetterList();
              });
            })
        }else{
          // cansel
        }
      })
    },
    drNewsLetterDeleteClear() {
      this.drDeleteRows = [];
      this.items.forEach(function (el, idx, arr){
        el.selectchecked = false;
      });
    },
    newsLetterInfoGo(row) {
      var self = this;
      self.$session.set('newsLetterCode', row.letter_code);
      location.href = '#/letter/newsletter/form/?status=update';
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/letter/component/LetterList.vue